var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 88,
    viewBox: "0 0 89 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7334 30C41.4197 30 38.7334 32.6863 38.7334 36C38.7334 39.3137 41.4197 42 44.7334 42C48.0471 42 50.7334 39.3137 50.7334 36C50.7334 32.6863 48.0471 30 44.7334 30ZM34.7334 36C34.7334 30.4772 39.2106 26 44.7334 26C50.2562 26 54.7334 30.4772 54.7334 36C54.7334 41.5228 50.2562 46 44.7334 46C39.2106 46 34.7334 41.5228 34.7334 36Z",
    fill: "#1D1D1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7334 57.2C28.7334 52.076 32.9876 48 38.118 48H51.3488C56.4792 48 60.7334 52.076 60.7334 57.2V62H56.7334V57.2C56.7334 54.38 54.3661 52 51.3488 52H38.118C35.1007 52 32.7334 54.38 32.7334 57.2V62H28.7334V57.2Z",
    fill: "#1D1D1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7334 75.714C45.3517 75.4614 46.1604 75.1152 47.1032 74.6749C49.3935 73.6052 52.4201 72.0058 55.4202 69.8792C61.588 65.5072 66.7334 59.5849 66.7334 52.14V25.7722L44.7334 12.6569L22.7334 25.7722V52.14C22.7334 59.5849 27.8788 65.5072 34.0466 69.8792C37.0467 72.0058 40.0733 73.6052 42.3636 74.6749C43.3064 75.1152 44.1151 75.4614 44.7334 75.714ZM18.7334 23.5L44.7334 8L70.7334 23.5V52.14C70.7334 71 44.7334 80 44.7334 80C44.7334 80 18.7334 71 18.7334 52.14V23.5Z",
    fill: "#00A88E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.c0793c0d41c35f9562b5a9faff11ebb3.svg";
export { ForwardRef as ReactComponent };